import '../styles/Experience.css';
import { TargetExperience } from './ui/TargetExperience.jsx';

export function Experience(){
  return(
    <section id="experience" className="experience">
      <h3 className="title">Experiencia profesional</h3>

      <div className="experience-content">

        <TargetExperience
          period="Ago. 2025 – Actualidad"
          role="Especialista en Sistemas y Consultor de Transformación Digital"
          org="Freelance, Cusco"
        />

        <TargetExperience
          period="Abr. 2020 – Actualidad"
          role="Analista Programador / Desarrollador de Software"
          org="CEC Guamán Poma de Ayala, Cusco"
          points={[
            "Lideré la transformación digital de servicios municipales: desarrollé, implementé y mantuve sistemas web y móviles para once municipalidades de la región Cusco (trámite documentario, consulta pública y control de limpieza urbana) sobre bases de datos SQL Server y MySQL con respaldo y disponibilidad garantizados.",
            "Implanté los sistemas en servidores y hosting municipales y capacité al personal de diez municipalidades; entregué documentación técnica y manuales de usuario para que las soluciones se sostengan en el tiempo.",
            "Diseñé un Sistema de Información Geográfica (SIG) con PyQGIS y SQL Server para monitorear compactadores y rutas de recolección, y mejorar la planificación operativa municipal.",
            "Organicé y desarrollé la plataforma de las Jornadas de Modernización y Transformación Digital en la Gestión Pública: más de 200 inscritos y más de 70% menos de tiempo en validar asistencia y certificar.",
          ]}
        />

        <TargetExperience
          period="Oct. 2019 – Mar. 2020"
          role="Practicante de Desarrollo de Software"
          org="CEC Guamán Poma de Ayala, Cusco"
          points={[
            "Participé en el desarrollo y mantenimiento de sistemas web institucionales y di soporte técnico a los procesos de digitalización de la organización.",
          ]}
        />

        <TargetExperience
          period="2017 – 2024"
          role="Operador Informático / Tecnológico"
          org="INEI y MINEDU, Cusco"
          points={[
            "Operador tecnológico en siete procesos de evaluación censal y de concurso público a nivel nacional, entre ellos el Censo Nacional 2017 y los concursos de ingreso y ascenso en la Carrera Pública Magisterial.",
          ]}
        />

      </div>
    </section>
  );
}
